import * as React from "react";
import { FontSizes, FontWeights } from "@fluentui/react";
import ReturnBack from "../Components/ReturnBack";

export default function InnerContent(props) {
    return (
        <div>
            {props.delete && <div style={{position: "absolute", top: 10, right: 10}}>{props.delete}</div>}
            {props.backTo && <div style={{position: "absolute", top: 10, left: 10}}><ReturnBack to={props.backTo}/></div>}
            {props.subtitle && <p style={{fontSize: FontSizes.size18, fontWeight: FontWeights.light, margin: 0}}>{props.subtitle}</p>}
            {props.title && <h3 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.regular, margin: 0}}>{props.title}</h3>}
            {props.children}
        </div>
    )
}